import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const publicToken = 'Public-Token'
const LANG_KEY = 'lang'
const IS_PAGE_TAG_MIX_MANUAL_KEY = 'isPageTagMixManual1'
const IS_PAGE_TAG_MIX_MANUAL_KEY_OLD = 'isPageTagMixManual'

function getTokenCookieOptions() {
  // kj.qizhishangke.com
  // [kj, qizhishangke, com]
  // [localhost]
  const ret = {
    domain: window.location.hostname
  }
  const tokenArr = window.location.hostname.split('.') || []
  if (tokenArr.length > 2) {
    ret.domain = tokenArr.slice(-2).join('.')
  }

  return ret
}

export function getToken() {
  return Cookies.get(TokenKey)
}
export function getSid() {
  return Cookies.get('sid')
}
export function setToken(token, params) {
  const defaultParams = getTokenCookieOptions()
  return Cookies.set(TokenKey, token, { ...defaultParams, ...params })
}
export function removeCurrentToken() {
  return Cookies.remove(TokenKey)
}
export function removeToken(params) {
  const defaultParams = getTokenCookieOptions()
  return Cookies.remove(TokenKey, { ...defaultParams, ...params })
}
export function setPublicToken(token, params) {
  console.log(token, params)
  const defaultParams = getTokenCookieOptions()
  return Cookies.set(publicToken, token, { ...defaultParams, ...params })
}
export function removePublicToken(params) {
  const defaultParams = getTokenCookieOptions()
  return Cookies.remove(publicToken, { ...defaultParams, ...params })
}

export function setSid(sid) {
  return Cookies.set('sid', sid)
}
export function removeSid() {
  return Cookies.remove('sid')
}

export function getLangCookie(value, params) {
  return Cookies.get(LANG_KEY)
}
export function setLangCookie(value, params) {
  const defaultParams = getTokenCookieOptions()
  return Cookies.set(LANG_KEY, value, { ...defaultParams, ...params })
}
export function removeLangCookie(value, params) {
  return Cookies.remove(LANG_KEY)
}

export function getIsPageTagManualCookie(value, params) {
  return Cookies.get(IS_PAGE_TAG_MIX_MANUAL_KEY)
}
export function setIsPageTagManualCookie(value, params) {
  const defaultParams = getTokenCookieOptions()
  // 兼容老版本的逻辑
  Cookies.set(IS_PAGE_TAG_MIX_MANUAL_KEY_OLD, value, { ...defaultParams, ...params })
  return Cookies.set(IS_PAGE_TAG_MIX_MANUAL_KEY, value, { ...defaultParams, ...params })
}
export function removeIsPageTagManualCookie(value, params) {
  return Cookies.remove(IS_PAGE_TAG_MIX_MANUAL_KEY)
}

export function setShopNoticeVisible(v) {
  const defaultParams = getTokenCookieOptions()
  return Cookies.set('shopNoticeVisible', v, { ...defaultParams })
}
